import { ReportManagementsArray } from '../../../types/reportsManagement/ReportManagementGetResponse';
import { formatProjectName } from '../../../utils/formatProjectName';
import { formatYmdDisplay } from '../../../utils/formatYmdDisplay';
import { formatHmDisplay } from '../../../utils/formatHmDisplay';
import { FormCheck } from 'react-bootstrap';
import EditAndDeleteButton from '../../../components/button/EditAndDeleteButton';
import { MAN_HOURS_CATEGORY_KEYS } from '../../../types/businessReport/BusinessReportPutRequest';

interface RenderReportManagementRowProps {
  item: ReportManagementsArray;
  onEdit: (item: ReportManagementsArray) => void;
  onDelete: (item: ReportManagementsArray) => void;
}

const RenderReportManagementRow = ({
  item,
  onEdit,
  onDelete,
}: RenderReportManagementRowProps) => {
  return (
    <>
      <td>{formatYmdDisplay(item.date)}</td>
      <td>{item.employeeCode}</td>
      <td>{item.employeeName}</td>
      <td>{item.projectNumber}</td>
      <td>{formatProjectName(item.projectName)}</td>
      {MAN_HOURS_CATEGORY_KEYS.map((key) => (
        <td key={key}>
          <FormCheck
            type="radio"
            name={`manHoursCategory-edit-${item.id}`}
            checked={item.manHoursCategory === key}
            readOnly
          />
        </td>
      ))}
      <td>{formatHmDisplay(item.startTime)}</td>
      <td>{formatHmDisplay(item.endTime)}</td>
      <td>{item.manHoursTotal}</td>
      <td>
        <EditAndDeleteButton
          onEdit={() => onEdit(item)}
          onDelete={() => onDelete(item)}
          editingRowIndex={item.id}
        />
      </td>
    </>
  );
};

export default RenderReportManagementRow;
